/** Better Auth's Eater realm in Nova, see apps/nova/src/auth/eater.ts. */
const BASE_PATH = "/account/api/v1/auth";
// Better Auth's per-IP window, for a 429 that comes without the header.
const DEFAULT_RETRY_AFTER_SECONDS = 60;
function rateLimited(answer) {
    if (answer.status !== 429)
        return null;
    const seconds = Number(answer.retryAfter);
    return {
        type: "rate-limited",
        rateLimitedFor: answer.retryAfter !== null && Number.isInteger(seconds) && seconds > 0
            ? seconds
            : DEFAULT_RETRY_AFTER_SECONDS,
    };
}
const FAILED_VERIFICATION = new Set([
    "INVALID_OTP",
    "OTP_EXPIRED",
    "INVALID_EMAIL",
    "VALIDATION_ERROR",
    "OTP_RECENTLY_SENT",
]);
function unexpected(what) {
    throw new Error(`Could not ${what}`);
}
// Pendolino's eager bundle reaches this module, and Babel compiles it without
// regenerator-runtime, so no async/await here.
function call(path, locale, body) {
    return fetch(`${BASE_PATH}${path}`, {
        method: body ? "POST" : "GET",
        credentials: "same-origin",
        headers: {
            Accept: "application/json",
            "X-Locale": locale,
            ...(body ? { "Content-Type": "application/json" } : {}),
        },
        body: body ? JSON.stringify(body) : undefined,
    }).then((response) => response
        .json()
        .catch(() => null)
        .then((data) => ({
        ok: response.ok,
        status: response.status,
        data,
        code: typeof data === "object" && data !== null && "code" in data
            ? String(data.code)
            : undefined,
        retryAfter: response.headers.get("X-Retry-After"),
    })));
}
/**
 * Nova's answers, in the UI's terms. A network failure or an answer the UI
 * has no words for rejects.
 */
export function createEaterAuthClient(locale) {
    return {
        session: () => call("/get-session", locale).then((answer) => answer.ok
            ? answer.data
            : unexpected("read the session")),
        sendCode: (email) => call("/email-otp/send-verification-otp", locale, {
            email,
            type: "sign-in",
        }).then((answer) => {
            var _a;
            // Inside the cooldown Nova refuses with OTP_RECENTLY_SENT, but the earlier code still works.
            if (answer.ok || answer.code === "OTP_RECENTLY_SENT")
                return { type: "sent" };
            if (answer.code === "INVALID_EMAIL" ||
                answer.code === "VALIDATION_ERROR")
                return { type: "invalid-email" };
            return (_a = rateLimited(answer)) !== null && _a !== void 0 ? _a : unexpected("request a Login Code");
        }),
        signIn: (email, code) => call("/sign-in/email-otp", locale, { email, otp: code }).then((answer) => {
            var _a;
            if (answer.ok)
                return {
                    type: "signed-in",
                    eater: answer.data,
                };
            // A code is minted for an unknown address too, so a burned one says nothing about the address.
            if (answer.code === "TOO_MANY_ATTEMPTS")
                return { type: "code-burned" };
            // Nova answers every other failed verification alike, hiding the address's state.
            if (answer.code !== undefined && FAILED_VERIFICATION.has(answer.code))
                return { type: "failed" };
            return (_a = rateLimited(answer)) !== null && _a !== void 0 ? _a : unexpected("verify the Login Code");
        }),
        signOut: () => call("/sign-out", locale, {}).then((answer) => {
            if (!answer.ok)
                unexpected("sign out");
        }),
    };
}
